// extracted by mini-css-extract-plugin
export default {"print-container":"_8slRW","printContainer":"_8slRW"};